/**
 * Threshold is how far the viewport is within the container
 * rootMargin is how far away the viewport is from the container
 *
 * All placement will have different optimal settings.
 * Sometimes it might even differ per brand
 *
 * @param placementId
 */
export function getInViewSettingsByPlacementId(placementId) {
  switch (placementId) {
    case 'top_1':
      return {
        threshold: 0.5,
        rootMargin: 0
      };
    case 'middle_1':
      return {
        threshold: 0.0,
        rootMargin: -50
      };
    case 'middle_2':
      return {
        threshold: 0.0,
        rootMargin: -100
      };
    default:
      return {
        threshold: 0.0,
        rootMargin: 0
      };
  }
}
